const WASCO_LOCAL_EMAIL_SUFFIX = '@wasco.local';
const DISPLAY_NAME_ALIASES: Record<string, string> = {
  'warehouse system': 'WH Team',
};

function titleCaseWords(value: string): string {
  return value
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function sanitizeUserDisplay(value?: string | null): string {
  const text = String(value ?? '').trim();
  if (!text) return '';
  const lower = text.toLowerCase();
  if (DISPLAY_NAME_ALIASES[lower]) return DISPLAY_NAME_ALIASES[lower];
  if (!lower.endsWith(WASCO_LOCAL_EMAIL_SUFFIX)) return text;
  const localPart = text.slice(0, text.length - WASCO_LOCAL_EMAIL_SUFFIX.length).trim();
  if (!localPart) return '';
  return titleCaseWords(localPart.replace(/[._-]+/g, ' ').replace(/\s+/g, ' ').trim());
}

export function sanitizeWmsTeamDisplay(value?: string | null): string {
  const text = sanitizeUserDisplay(value);
  const normalized = text.trim().toLowerCase();
  if (!normalized) return '';
  if (normalized.includes('qc')) return 'QC Team';
  if (normalized.includes('warehouse') || normalized === 'wh team') return 'WH Team';
  if (normalized.includes('supervisor') || normalized.includes('approver')) return 'Supervisor';
  if (normalized.includes('operation') || normalized.includes('requester')) return 'Operation';
  return text;
}

export function sanitizeUserEmail(value?: string | null): string | null {
  const text = String(value ?? '').trim();
  if (!text) return null;
  return text.toLowerCase().endsWith(WASCO_LOCAL_EMAIL_SUFFIX) ? null : text;
}
